import { t } from "@shared/utils/i18n";
import type { TableRowActionItem } from "@shared/components/UiTableRowActions/index.vue";

export const AMAZON_VC_LOGISTICS_PLATFORM_OPTIONS = [{ label: "Amazon", value: "amazon" }];

export const AMAZON_VC_LOGISTICS_TYPE_OPTIONS = [
    { label: "PO", value: "PO" },
    { label: "DF", value: "DF" },
];

/** 名称仅模糊搜索，不开放多项精确 */
export const AMAZON_VC_LOGISTICS_COMBINED_SEARCH_OPTIONS = [{ label: t("名称"), value: "name", exact: false }];

/** 列表项（/manage/warehouseVcLogisticsChannel/list 的 items[]） */
export interface AmazonVcLogisticsChannelItemApi {
    id: number | string;
    platformCode: string;
    platformLabel: string;
    vcType: string;
    vcTypeLabel: string;
    channelName: string;
    carrier: string;
    carrierLabel: string;
    logisticsType: string;
    logisticsTypeLabel: string;
    /** 跟踪号前缀 */
    trackingNumberPrefix?: string;
    mappingCount: number;
    status: number;
    statusLabel: string;
    createdBy: number;
    creatorName: string;
    /** 创建时间 */
    createTime: string;
    updatedAt?: string;
}

export interface AmazonVcLogisticsChannelRow {
    id: string;
    name: string;
    /** 列表展示：平台名称 */
    platform: string;
    platformCode: string;
    /** 列表展示：VC 类型文案 */
    vcType: string;
    vcTypeCode: string;
    /** 列表展示：物流商 */
    logisticsProvider: string;
    /** 提交/编辑用物流商原文 */
    carrier: string;
    /** 跟踪号前缀 */
    trackingNumberPrefix: string;
    /** 列表展示：物流类型文案 */
    logisticsType: string;
    logisticsTypeCode: string;
    creatorName: string;
    /** 创建时间 */
    createTime: string;
    status: number;
    statusLabel: string;
    mappingCount: number;
}

export function mapAmazonVcLogisticsChannelItem(item: AmazonVcLogisticsChannelItemApi): AmazonVcLogisticsChannelRow {
    return {
        id: item.id != null && item.id !== "" ? String(item.id) : "",
        name: item.channelName,
        platform: item.platformLabel || item.platformCode,
        platformCode: item.platformCode,
        vcType: item.vcTypeLabel || item.vcType,
        vcTypeCode: item.vcType,
        logisticsProvider: item.carrierLabel || item.carrier,
        carrier: item.carrier,
        trackingNumberPrefix: item.trackingNumberPrefix ?? "",
        logisticsType: item.logisticsTypeLabel || item.logisticsType,
        logisticsTypeCode: item.logisticsType,
        creatorName: item.creatorName,
        createTime: item.createTime || "",
        status: item.status,
        statusLabel: item.statusLabel,
        mappingCount: item.mappingCount ?? 0,
    };
}

/** 行内操作：仅编辑渠道 */
export function getAmazonVcLogisticsChannelRowActions(): TableRowActionItem[] {
    return [{ label: t("编辑"), key: t("编辑") }];
}
